import Advertising from './Advertising';

export default Advertising;
